import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDownIcon, MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { CONTACT } from '../data/modalities';
const PRODUCT_LINKS = [{
  label: 'Class IV Laser',
  href: '#category-class-iv-laser'
}, {
  label: 'Shockwave',
  href: '#category-shockwave'
}, {
  label: 'High Energy Inductive Therapy',
  href: '#category-high-energy-inductive-therapy'
}, {
  label: 'Whole Body Red Light / LED Therapy',
  href: '#category-whole-body-red-light-led-therapy'
}, {
  label: 'Thermal Imaging',
  href: '#category-thermal-imaging'
}, {
  label: 'Deep Oscillation',
  href: '#category-deep-oscillation'
}, {
  label: 'Used Equipment',
  href: '#category-used-equipment'
}, {
  label: 'Concierge Modality Suite',
  href: '#category-concierge-modality-suite'
}, {
  label: 'Neuro Reformer',
  href: '#category-neuro-reformer'
}, {
  label: 'RegenMedix',
  href: '#category-regenmedix'
}];
const NAV = [{
  label: 'Concierge Suite',
  href: '#concierge'
}, {
  label: 'Used Equipment',
  href: '#used-equipment'
}, {
  label: 'About',
  to: '/about'
}, {
  label: 'Contact',
  to: '/contact'
}];
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [desktopProductsOpen, setDesktopProductsOpen] = useState(false);
  const [mobileProductsOpen, setMobileProductsOpen] = useState(false);
  const location = useLocation();
  function closeAllMenus() {
    setMobileMenuOpen(false);
    setDesktopProductsOpen(false);
    setMobileProductsOpen(false);
  }
  function handleSamePageAnchorClick(event: React.MouseEvent<HTMLAnchorElement>, hash: string) {
    event.preventDefault();
    const target = document.getElementById(hash.slice(1));
    if (target) {
      window.history.pushState(null, '', hash);
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
    closeAllMenus();
  }
  return <header className="sticky top-0 z-50 w-full border-b border-white/15 bg-navy text-white shadow-[0_8px_24px_-16px_rgba(9,10,42,0.8)]" data-id="element-55" data-mp="1wcxqz2xuqr2m">
      <div className="mx-auto flex h-[82px] max-w-7xl items-center justify-between px-5 sm:px-8" data-id="element-56" data-mp="1hni2jtlsmxq3">
        <Link to="/" aria-label="JAG Medical Solutions home" onClick={closeAllMenus} className="rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy" data-id="element-57" data-mp="1ml07za0lqutc">
          <Logo data-id="element-58" data-mp="yqqi3guimckg" />
        </Link>

        <nav className="hidden items-center gap-4 xl:flex" aria-label="Primary" data-id="element-59" data-mp="13nz0nijksim8">
          <Link to="/" className={`relative py-2 text-[14px] font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy ${location.pathname === '/' && !location.hash ? 'text-teal-light' : 'text-white/80 hover:text-teal-light'}`} data-id="element-60" data-mp="13ptpv91vqww4">
            Home
            {location.pathname === '/' && !location.hash && <span className="absolute bottom-0 left-0 h-0.5 w-full bg-teal" data-id="element-61" data-mp="w5j1x1d5ftkl" />}
          </Link>

          <div className="group relative" onMouseLeave={() => setDesktopProductsOpen(false)} onKeyDown={event => {
          if (event.key === 'Escape') setDesktopProductsOpen(false);
        }} data-id="element-62" data-mp="rczi3mnvc27c">
            <button type="button" aria-controls="desktop-products-menu" aria-expanded={desktopProductsOpen} aria-haspopup="menu" onClick={() => setDesktopProductsOpen(value => !value)} className={`inline-flex items-center gap-1.5 py-2 text-[14px] font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy ${desktopProductsOpen ? 'text-teal-light' : 'text-white/80 hover:text-teal-light'}`} data-id="element-63" data-mp="1f325vqkr2m05">
              Products
              <ChevronDownIcon className={`h-4 w-4 transition-transform ${desktopProductsOpen ? 'rotate-180' : ''}`} data-id="element-64" data-mp="2cwlb6dz3v090" />
            </button>

            <div id="desktop-products-menu" className={`invisible pointer-events-none absolute left-0 top-full z-[60] mt-1 w-[340px] origin-top rounded-lg border border-white/15 bg-navy p-2 opacity-0 shadow-2xl shadow-black/35 transition-[opacity,transform,visibility] duration-150 group-hover:visible group-hover:pointer-events-auto group-hover:opacity-100 group-focus-within:visible group-focus-within:pointer-events-auto group-focus-within:opacity-100 ${desktopProductsOpen ? 'visible pointer-events-auto opacity-100' : ''}`} role="menu" aria-label="Products" data-id="element-65" data-mp="1k85uln0bs9vk">
              <div className="grid gap-0.5" data-id="element-66" data-mp="xype2a79iel4">
                {PRODUCT_LINKS.map(item => <a key={item.href} href={item.href} onClick={event => handleSamePageAnchorClick(event, item.href)} className="whitespace-nowrap rounded-md px-3 py-2 text-[14px] font-medium text-white/85 transition-colors hover:bg-white/10 hover:text-teal-light focus-visible:outline-none focus-visible:bg-white/10 focus-visible:text-teal-light" role="menuitem" data-id="element-67" data-mp="t0ffrqq8qxva">
                    {item.label}
                  </a>)}
              </div>
              <div className="my-2 border-t border-white/15" data-id="element-68" data-mp="1b2n2rsyjof2" />
              <a href="#product-of-the-month" onClick={event => handleSamePageAnchorClick(event, '#product-of-the-month')} className="block rounded-md px-3 py-2 text-[14px] font-semibold text-teal-light transition-colors hover:bg-white/10 focus-visible:outline-none focus-visible:bg-white/10" role="menuitem" data-id="element-69" data-mp="3sgc43tyz4scj">
                Product of the Month
              </a>
            </div>
          </div>

          {NAV.map(item => {
          const className = `relative py-2 text-[14px] font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy ${location.pathname === item.to ? 'text-teal-light' : 'text-white/80 hover:text-teal-light'}`;
          const activeIndicator = item.to && location.pathname === item.to && <span className="absolute bottom-0 left-0 h-0.5 w-full bg-teal" data-id="element-70" data-mp="3rqiipyztywt2" />;
          return item.href ? <a key={item.href} href={item.href} onClick={event => handleSamePageAnchorClick(event, item.href)} className={className} data-id="element-71" data-mp="o4bh7iz4y1az">
                {item.label}
              </a> : <Link key={item.to} to={item.to ?? '/'} className={className} data-id="element-72" data-mp="2ik0ev5mzu62c">
                {item.label}
                {activeIndicator}
              </Link>;
        })}
        </nav>

        <div className="flex items-center gap-3" data-id="element-73" data-mp="1pvbbt12dnqny">
          <a href={CONTACT.phoneHref} className="hidden items-center gap-2 rounded-full bg-teal px-5 py-2.5 text-[13.5px] font-semibold text-white transition-colors hover:bg-teal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-navy sm:inline-flex" data-id="element-74" data-mp="1pw4bji2x5fwl">
            <PhoneIcon className="h-4 w-4" data-id="element-75" data-mp="3aamzec0jdrgr" />
            Call {CONTACT.phone}
          </a>
          <button type="button" className="inline-flex h-10 w-10 items-center justify-center rounded-lg text-white transition-colors hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy xl:hidden" onClick={() => setMobileMenuOpen(value => !value)} aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'} aria-expanded={mobileMenuOpen} data-id="element-76" data-mp="369uolec0neid">
            {mobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-77" data-mp="1mcvn7sc0oqnk" /> : <MenuIcon className="h-6 w-6" data-id="element-78" data-mp="1rbyt1eztn0wl" />}
          </button>
        </div>
      </div>

      {mobileMenuOpen && <div className="border-t border-white/15 bg-navy xl:hidden" data-id="element-79" data-mp="1wc4g0hv5bz8c">
          <nav className="mx-auto flex max-w-7xl flex-col px-5 py-3 sm:px-8" aria-label="Mobile" data-id="element-80" data-mp="21axvgftzu0b5">
            <Link to="/" onClick={closeAllMenus} className="border-b border-white/10 py-3 text-[15px] font-medium text-white/85 transition-colors hover:text-teal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-inset" data-id="element-81" data-mp="1z4uy97zycto">
              Home
            </Link>

            <div className="border-b border-white/10" data-id="element-82" data-mp="2bdtgdih8xwgk">
              <button type="button" onClick={() => setMobileProductsOpen(value => !value)} aria-expanded={mobileProductsOpen} className="flex w-full items-center justify-between py-3 text-left text-[15px] font-medium text-white/85 transition-colors hover:text-teal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-inset" data-id="element-83" data-mp="2bc8k9ofaa5gl">
                Products
                <ChevronDownIcon className={`h-4 w-4 transition-transform ${mobileProductsOpen ? 'rotate-180' : ''}`} data-id="element-84" data-mp="2p5rih9cjis38" />
              </button>
              {mobileProductsOpen && <div className="mb-3 rounded-lg border border-white/10 bg-white/[0.05] p-2" data-id="element-85" data-mp="1dt76by79bn22">
                  {PRODUCT_LINKS.map(item => <a key={item.href} href={item.href} onClick={event => handleSamePageAnchorClick(event, item.href)} className="block rounded-md px-3 py-2.5 text-sm font-medium text-white/80 hover:bg-white/10 hover:text-teal-light focus-visible:outline-none focus-visible:bg-white/10" data-id="element-86" data-mp="184m81ac169vs">
                      {item.label}
                    </a>)}
                  <div className="my-1.5 border-t border-white/15" data-id="element-87" data-mp="25r31u5lk25cs" />
                  <a href="#product-of-the-month" onClick={event => handleSamePageAnchorClick(event, '#product-of-the-month')} className="block rounded-md px-3 py-2.5 text-sm font-semibold text-teal-light hover:bg-white/10 focus-visible:outline-none focus-visible:bg-white/10" data-id="element-88" data-mp="20s8ldab28svu">
                    Product of the Month
                  </a>
                </div>}
            </div>

            {NAV.map(item => item.href ? <a key={item.href} href={item.href} onClick={event => handleSamePageAnchorClick(event, item.href)} className="border-b border-white/10 py-3 text-[15px] font-medium text-white/85 transition-colors hover:text-teal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-inset" data-id="element-89" data-mp="2daucj9vkz8gm">
                  {item.label}
                </a> : <Link key={item.to} to={item.to ?? '/'} onClick={closeAllMenus} className="border-b border-white/10 py-3 text-[15px] font-medium text-white/85 transition-colors hover:text-teal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-inset" data-id="element-90" data-mp="3jshh7ij8gc70">
                  {item.label}
                </Link>)}
            <a href={CONTACT.phoneHref} onClick={closeAllMenus} className="mt-4 inline-flex items-center justify-center gap-2 rounded-full bg-teal px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-teal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-91" data-mp="38cmokmym7hdw">
              <PhoneIcon className="h-4 w-4" data-id="element-92" data-mp="21m042bwuvp" />
              Call {CONTACT.phone}
            </a>
          </nav>
        </div>}
    </header>;
}